import React, {Component} from 'react';
import {connect} from 'react-redux';
import DealersActions from '../../redux/DealersRedux';
import DictionariesActions from '../../redux/DictionariesRedux';
import {
  LeftHorizontalBarCell,
  RightHorizontalBarCell
} from './components/HorizontalBarCells';
import PageWithTable from '../../components/PageWithTable';
import Forbidden from '../../components/Forbidden';
import {withTranslation} from 'react-i18next';

const columns = t => ([
  {
    key: 'name',
    dataKey: 'name',
    title: t("Dealer's Name"),
    sortable: true,
    minWidth: 320,
    width: 0,
    flexGrow: 1,
  },
  {
    key: 'activeUsers',
    dataKey: 'activeUsers',
    title: t("Active users"),
    sortable: true,
    width: 170,
    cellRenderer: ({cellData}) => {
      return (<LeftHorizontalBarCell maxValue={100} count={cellData} />)
    },
    style: {padding: 0}
  },
  {
    key: 'inactiveUsers',
    dataKey: 'inactiveUsers',
    title: t("Deactivated users"),
    sortable: true,
    width: 170,
    cellRenderer: ({cellData}) => {
      return (<RightHorizontalBarCell maxValue={100} count={cellData} />)
    },
    style: {padding: 0}
  },
  {
    key: 'city.region.name',
    dataKey: 'city.region.name',
    title: t("Region"),
    sortable: true,
    width: 0,
    flexGrow: 1,
  },
  {
    key: 'city.name',
    dataKey: 'city.name',
    title: t("City"),
    sortable: true,
    width: 0,
    flexGrow: 1,
  },
]);

class DealersPage extends Component {
  render() {
    const {
      dealers,
      fetching,
      totalPages,
      getDealers,
      dictionaries,
      getDictionaries,
      permissions,
      t,
    } = this.props;

    if (!permissions.dealers) {
      return <Forbidden />;
    }

    return (
      <PageWithTable
        actionButton={{
          title: t('New dealer'),
          href: '/dealers/new',
        }}
        filters={[
          {
            keyName: 'regionIds',
            placeholder: t('By region'),
            data: dictionaries.regions.data,
            fetching: dictionaries.regions.fetching,
            getData: getDictionaries('regions'),
          }
        ]}
        dataColumns={columns(t)}
        data={dealers}
        dataFetching={fetching}
        dataTotalPages={totalPages}
        getData={getDealers}
        {...this.props}
        permissions={permissions.dealer}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    permissions: state.userProfile.permissions,
    dealers: state.dealers.data,
    totalPages: state.dealers.totalPages,
    fetching: state.dealers.fetching,
    dictionaries: state.dictionaries,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getDealers: params => dispatch(DealersActions.dealersRequest(params)),
    getDictionaries: name => () => dispatch(DictionariesActions.dictionariesRequest(name)),
  };
};

export default withTranslation('dealers', 'common')(connect(
  mapStateToProps,
  mapDispatchToProps,
)(DealersPage));